import { Button } from 'react-bootstrap';
import React from 'react';
import { useSelector } from 'react-redux';
import { action } from '../../lib/actionHelpers.js';

const stableObject = {};
const stableArray = [];

const BoundButton = ({ type, label, onClick, formId, className, disabled = undefined }) => {
  const isSubmit = !type || type === 'submit';
  const variant = !isSubmit ? 'secondary' : 'primary';
  const buttonLabel = label || (isSubmit ? 'Save' : type === 'cancel' ? 'Cancel' : '');

  const invalids = useSelector((state) => (state.ui.boundForms[formId] || stableObject).invalids || stableArray);
  const empties = useSelector((state) => (state.ui.boundForms[formId] || stableObject).empties || stableArray);
  const isValid = invalids.length < 1 && empties.length < 1;
  const isDisabled = isSubmit && !isValid;

  const handleClick = (e) => {
    e.preventDefault();
    if (isSubmit) {
      action('uiToggleFormValidation', { formId: formId, validating: true });
      setTimeout(() => {
        action('uiToggleFormValidation', { formId: formId, validating: false });
      }, 0);
      if (!isValid) {
        return;
      }
    }
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <Button variant={variant} className={`btn btn-primary ${className || ''} ${isDisabled || disabled === true ? 'disabled' : ''}`} onClick={(e) => handleClick(e)}>
      {buttonLabel}
    </Button>
  );
};

export default BoundButton;
